export default __webpack_public_path__ + "static/media/yt.b46a7b98.jpg";